import React from 'react'
import Resources from '../pages/Resources'
const CircuitDesign = () => {
  return (
    <div>
            <Resources />
    </div>
  )
}

export default CircuitDesign;